export function getAmountOfNightsBetween(startDate: string, endDate: string): number {
  return Math.ceil((new Date(endDate).getTime() - new Date(startDate).getTime()) / (1000 * 60 * 60 * 24));
}
